import { Component } from '@angular/core';

@Component({
  selector: 'app-cinverify',
  templateUrl: './cinverify.component.html',
  styleUrls: ['./cinverify.component.css']
})
export class CinverifyComponent {
ShowCard:any;

}
